/**
 * Do not edit directly!
 * Read more: https://ink.carta.com/contributing/css-styleguide/#tokens
 */

export const subNavTokens = {
  CoreSpacingVertical: '6px',
  CoreSpacingHorizontal: '12px',
  CoreGapHorizontal: '8px',
  CoreFontSize: '14px',
  CoreFontWeight: '500',
  CoreFontColorInitial: '#1c2222',
  CoreFontColorSelected: '#000000',
  CoreBorderRadius: '8px',
  CoreBackgroundColorHover: '#dedfdf',
  CoreBackgroundColorPressed: '#c4c4c4',
  CoreBackgroundColorSelected: '#dedfdf',
  CoreOutlineOffset: '0px',
  CoreOutlineStroke: '2px solid',
  CoreOutlineColor: '#285da3',
} as const;
